import React from 'react'

const ErrorIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="#FF5978" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.80029 12.1998L12.2003 5.7998" stroke="#FF5978" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.2003 12.1998L5.80029 5.7998" stroke="#FF5978" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default ErrorIcon